<template>
  <div class="pie" :id="`pie-${idKey}`"></div>
</template>
<script>
  // Pie Chart
  import echarts from 'echarts'
  export default {
    data() {
      return {}
    },
    computed: {
      pieOptions () {
        return {
          // 标题
          title: {
            text: this.title,
            x: 'center',
            subtext: `总量: ${this.total}`
          },
          // 提示信息显示方式
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/> {b} : {c} ({d}%)'
          },
          // 
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 50,
            bottom: 20,
            data: this.deviceTypes
            // 选中状态
            // selected: data.selected
          },
          series: [{
            name: '型号',
            type: 'pie',
            radius: ['0%', '40%'],
            label: {
              normal: {
                show: true,
                // position: 'inside',
                formatter: '{b}: {c}'
              }
            },
            center: ['40%', '50%'],
            data: this.seriesData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        }
      } 
    },
    props: {
      idKey: {
        // type: String || Number,
        // default: Math.floor(Math.random() * 1000)
        required: true
      },
      title: {
        type: String,
        required: true
      },
      deviceTypes: {
        type: Array,
        required: true
      },
      seriesData: {
        type: Array,
        required: true
      },
      total: {
        type: Number,
        required: true
      }
    },
    // watch: {
    //   // 监听seriesData 如果数据发生变化就重新渲染
    //   seriesData (newValue, oldValue) {
    //     if (newValue !== oldValue) {
    //       this.reloadPie()
    //     }
    //   }
    // },
    methods: {
      // 渲染饼图
      renderPie() {
        // console.log(this.idKey)
        // 创建饼图
        let dom = document.getElementById(`pie-${this.idKey}`)
        // console.log(dom)
        let pie = echarts.init(dom)
        this.pie = pie
        // 渲染
        // console.log(this.pieOptions)
        // pie.setOption(this.pieOptions)
        this.reloadPie()
      },
      reloadPie () {
        // console.log('reload')
        // console.log(this.pieOptions.series[0].data)
        this.pie && this.pie.setOption(this.pieOptions)
      }
    },
    mounted() {
      this.renderPie()
    }
  }
</script>
<style lang="less" scoped>
.pie {
  height: 30vh;
}
</style>